import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-navy-900 border-t border-navy-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="mb-6">
              <Link to="/">
                <img src="/images/logo.jpeg" alt="BPR Electric" className="h-12 w-auto" />
              </Link>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Commercial electrical contractor serving Massachusetts. Self-performed installation on commercial, mixed-use, and residential projects.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/bpr-electric" target="_blank" rel="noreferrer" className="text-slate-400 hover:text-primary-500 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://www.facebook.com/bprelectric" target="_blank" rel="noreferrer" className="text-slate-400 hover:text-primary-500 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://www.twitter.com/bprelectric" target="_blank" rel="noreferrer" className="text-slate-400 hover:text-primary-500 transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading uppercase text-white text-sm tracking-widest mb-6">Capabilities</h3>
            <ul className="space-y-3">
              <li><Link to="/capabilities" className="text-slate-400 hover:text-white transition-colors text-sm">Preconstruction Planning</Link></li>
              <li><Link to="/capabilities" className="text-slate-400 hover:text-white transition-colors text-sm">Self-Performed Installation</Link></li>
              <li><Link to="/capabilities" className="text-slate-400 hover:text-white transition-colors text-sm">Solar &amp; EV Infrastructure</Link></li>
              <li><Link to="/capabilities" className="text-slate-400 hover:text-white transition-colors text-sm">Design-Build Collaboration</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading uppercase text-white text-sm tracking-widest mb-6">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/projects" className="text-slate-400 hover:text-white transition-colors text-sm">Projects</Link></li>
              <li><Link to="/capabilities" className="text-slate-400 hover:text-white transition-colors text-sm">Capabilities</Link></li>
              <li><Link to="/about" className="text-slate-400 hover:text-white transition-colors text-sm">About</Link></li>
              <li><Link to="/career" className="text-slate-400 hover:text-white transition-colors text-sm">Careers</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-white transition-colors text-sm">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading uppercase text-white text-sm tracking-widest mb-6">Contact Info</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <MapPin className="h-5 w-5 text-primary-500 mr-3 mt-0.5 flex-shrink-0" />
                <span className="text-slate-400 text-sm">Massachusetts &amp; Greater Boston Area</span>
              </div>
              <div className="flex items-center">
                <Phone className="h-5 w-5 text-primary-500 mr-3 flex-shrink-0" />
                <span className="text-slate-400 text-sm">(617) 848-3498</span>
              </div>
              <div className="flex items-center">
                <Mail className="h-5 w-5 text-primary-500 mr-3 flex-shrink-0" />
                <span className="text-slate-400 text-sm">info@bprelectric.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-navy-600 mt-12 pt-8 text-center text-slate-400 text-sm">
          <p>&copy; 2025 BPR Electric. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
